import React from 'react';
import classNames from 'classnames';
import { withResponsiveContext } from '../responsive-listener/responsive-context';
import styles from './dotdotdot.scss';

type Props = {
  clamp: 'auto' | 'parent' | number;
  className?: string;
  useExactLineHeight?: boolean;
  maxLineCount?: number;
  as?: keyof JSX.IntrinsicElements;
  children?: React.ReactNode;
};

const DotDotDot: React.FC<Props> = (props) => {
  const type = props.as ?? 'span';

  // Convert clamp prop to CSS line clamp value
  const getLineClampValue = () => {
    if (props.clamp === 'auto' || props.clamp === 'parent') {
      return props.maxLineCount || 2;
    }
    return props.clamp;
  };

  const lineClampValue = getLineClampValue();

  const Element = () =>
    React.createElement(
      type,
      {
        ref: null,
        className: classNames(styles.root, props.className),
        style: {
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: lineClampValue,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
      props.children,
    );

  return <Element />;
};

// `withResponsiveContext` is used to force re-rendering of the component when root width changes.
export default withResponsiveContext(DotDotDot) as any as React.FC<Props>;
